import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 bg-primary-black text-primary-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-8">
            <h3 className="text-xl font-semibold mb-2">Kelton Oliveira</h3>
            <p className="text-sm text-gray-400">Terapeuta | Palestrante | Autor</p>
            <p className="text-sm italic mt-2 text-gray-400">Proclamo liberdade às mentes cativas.</p>
          </div>
          
          <div className="border-t border-gray-800 pt-6 mt-6">
            <p className="text-sm text-gray-400">© 2025 Kelton Oliveira. Todos os direitos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
